import { styled } from '@slal/ui';
import { Button } from '../Button';

export const PanelWrapper = styled.div``;

export const TabsWrapper = styled.div`
    display: flex;
    gap: 6px;
`;

export const TabButton = styled(Button)<{ isActive: boolean }>`
    flex: 1;
    min-width: auto;
    height: auto;
    padding: 12px;
    background-color: #ffffff;
    position: relative;
    border: 1px solid ${({ theme, isActive }) => (isActive ? theme.colors.blue__secondary__70 : '#e2e8f0')} !important;
    border-radius: 10px 10px 0 0;
    z-index: ${({ isActive }) => (isActive ? 1 : 0)};
    font-weight: bold;

    &:after {
        content: '';
        position: absolute;
        bottom: -3px;
        left: 0;
        right: 0;
        height: 4px;
        background-color: #ffffff;
        opacity: ${({ isActive }) => (isActive ? 1 : 0)};
        transition: opacity 0.2s ease-in-out;
    }

    &:not(:disabled):hover {
        background-color: ${({ isActive }) => (isActive ? '#ffffff' : '#f8fafc')};
    }

    transition:
        border-color 0.2s ease-in-out,
        background-color 0.2s ease-in-out;
`;

export const LabelContainer = styled.span<{ isActive: boolean }>`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
    color: ${({ theme, isActive }) => (isActive ? theme.colors.neutral__dark__20 : theme.colors.blue__secondary__70)};
`;

export const PrimaryLabel = styled.span`
    font-weight: 600;
`;

export const SecondaryLabel = styled.span`
    font-weight: normal;
`;

export const PanelContent = styled.div<{ hidden?: boolean }>`
    display: ${({ hidden }) => (hidden ? 'none' : 'flex')};
    flex-direction: column;
    gap: 12px;
    background-color: #ffffff;
    border: 1px solid ${({ theme }) => theme.colors.blue__secondary__70};
    border-radius: 0px 0px 8px 8px;
    padding: 24px;
    position: relative;
`;
